import { useEffect } from "react";
import { connect } from "react-redux";
import { separateNum } from "../../utils";
import { setUser } from "../../store/action/auth";
import Notification from "../../services/notification/Notification";
import CartService from "../../services/cart/Cart";
import { Warning } from "../../components/button";
import Empty from "./Empty";
import Item from "./Item";
import SideBar from "./SideBar";
import { Div, Row } from "./style";

const Cart = (props) => {
  const { user, carts, history, settings } = props;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const nextLevel = () => {
    if (user?.token) {
      if (CartService.getCartPrice(carts)?.price > settings.min_order)
        onChangeRoute("/carts/shipping");
      else
        Notification.danger(
          `سفارش شما باید حداقل ${separateNum(settings.min_order)} تومان باشد.`
        );
    } else {
      onChangeRoute("/login");

      Notification.danger("ابتدا باید وارد راحساب کاربری خود شوید");
    }
  };

  const onChangeRoute = (route, e, data) => {
    if (e) {
      e.preventDefault();
    }

    history.push(route, data);
  };

  return (
    <>
      <Div className="mx-1 mt-3">
        <Row className="row no-gutters">
          {CartService.getCartLength(carts) ? (
            <>
              {Object.keys(carts?.items).map((cart, index) => (
                <Item data={cart} key={index} index={index} />
              ))}
              <SideBar local>
                <Warning
                  title="ادامه فرآیند خرید"
                  className="d-block mt-3"
                  onClick={nextLevel}
                  sizeSpinner={20}
                />
              </SideBar>
            </>
          ) : (
            <Empty />
          )}
        </Row>
      </Div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.auth?.user,
    settings: state.settings?.settings,
    carts: state.carts?.carts,
  };
};

export default connect(mapStateToProps, { setUser })(Cart);
